/**
 * Fixed admin panel login (client-side only). Change before production.
 *
 * Optional .env overrides:
 *   REACT_APP_ADMIN_EMAIL
 *   REACT_APP_ADMIN_PASSWORD
 *
 * If you change these, update the gate in Postgres function public.admin_list_app_users
 * (see supabase/migrations) or the Users list RPC will reject the request.
 */
export const ADMIN_PANEL_EMAIL =
  process.env.REACT_APP_ADMIN_EMAIL || 'admin@tourascohotels.com';

export const ADMIN_PANEL_PASSWORD =
  process.env.REACT_APP_ADMIN_PASSWORD || 'TourascoAdmin2026';

export const ADMIN_SESSION_KEY = 'tourasco_admin_authenticated';

export const ADMIN_SESSION_EMAIL_KEY = 'tourasco_admin_email';

/** Cleared on admin sign-out. Used only to call admin_list_app_users RPC in this session. */
export const ADMIN_RPC_SESSION_PASSWORD_KEY = 'tourasco_admin_rpc_password_v1';
